/**
 * cropper-image is transformed around its own center (the CSS default `transform-origin`), so the
 * range below is centered on `naturalSize * (scale - 1) / 2` rather than on `0`.
 */

/** The [min, max] range `translate` must stay within for the image to fully cover `canvasSize`. */
export function getCoverTranslateBounds(naturalSize: number, scale: number, canvasSize: number): [number, number] {
	// `(scale - 1)`, not `-(1 - scale)`, so this is a plain `0` (not `-0`) at scale === 1.
	const max = (naturalSize * (scale - 1)) / 2;
	const min = canvasSize - (naturalSize * (1 + scale)) / 2;
	return [min, max];
}
